import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ImportAnnotationsBl } from '../../../importAnnotations.bl';
import { IImportAnnotationsStore } from '../../../importAnnotations.store';
import { ImportAnnotationsStep } from '../../../models/ImportAnnotationsSteps';
import { SelectFileStepModal } from './SelectFileStepModal';

export const SelectFileStepContainer = observer((): ReactElement => {
  const bl = useInjection(ImportAnnotationsBl.$);
  const store = useInjection(IImportAnnotationsStore.$);

  const handleHide = (): void => {
    bl.cancelImport();
  };

  const handleSubmit = async (): Promise<void> => {
    await bl.goToImportAnnotationsAsync();
  };

  const handleFileDropped = async (files: File[]): Promise<void> => {
    await bl.validateFileAsync(files[0]);
  };

  const isCurrentStep = store.currentStep === ImportAnnotationsStep.SelectFile;

  const canProceed = !!store.file && !store.fileValidationError;

  return (
    <SelectFileStepModal
      show={isCurrentStep}
      onFileDropped={handleFileDropped}
      onHide={handleHide}
      onSubmit={handleSubmit}
      canProceed={canProceed}
      fileValidationError={store.fileValidationError}
      fileName={store.fileName}
    />
  );
});
